import { Ampersand } from "../AppConstants"

export const aayuCardBenifitsList = [
    {
        title: 'One cover for the entire family',
        imageUrl: '/images/aayuCard/aayu_card_benefits_1.svg'
    },
    {
        title: 'Pay once ' + Ampersand + ' use for 12 months',
        imageUrl: '/images/aayuCard/aayu_card_benefits_2.svg'
    },
    {
        title: 'All specialties covered',
        imageUrl: '/images/aayuCard/aayu_card_benefits_3.svg'
    },
    {
        title: 'Supports multiple phones from one account',
        imageUrl: '/images/aayuCard/aayu_card_benefits_4.svg'
    },
]

export const familyTypes = [
    {
        label: 'Couple',
        value: 'Couple'
    },
    {
        label: 'Couple with kids',
        value: 'Couple with kids'
    },
    {
        label: 'Joint Family',
        value: 'Joint Family'
    },
    {
        label: 'Myself',
        value: 'Myself'
    }
]

export const typeOfProblems = [
    {
        title: 'Immunity',
        subTitle: '(Infection, Stomach ache etc.)',
        value: 'Immunity problems',
        checked: false
    },
    {
        title: 'Women Health',
        value: 'Women health',
        checked: false
    },
    {
        title: 'Lifestyle',
        subTitle: '(Skin, Sexual health, Mental Health, Bodyache, Digestion)',
        value: 'Lifestyle problems',
        checked: false
    },
    {
        title: 'Joint Related',
        value: 'Joint related problems',
        checked: false
    }
]